import React from "react"
import RatingStar from "@bodeboca/algolia/components/rating/star"
import {useTranslation} from "react-i18next"

const Rating = ({nid, path, ratingAverage, ratingCount, queryId}) => {
  const finalPath = path + "#block-productratings"
  const {t} = useTranslation()
  return (<div id="rating-element">
    <div className="product-rating-wrapper">
      <div className="product-rating-wrapper-inner">
        <div className="fivestar fivestar-small">
          <div className="fivestar-static-form-item fivestar-small">
            <div
              className="fivestar-widget-static fivestar-widget-static-average-votes fivestar-widget-static-5 clear-block">
              {[...Array(5)].map((x, i) => (<RatingStar
                index={i} key={i}
                ratingAverage={ratingAverage}/>))}
            </div>
            <div className="rating-numeric">{ratingAverage}</div>
          </div>
        </div>
        <div className="product-rating-num-comments">
          <a
            className="winebox-comments bbicon-opiniones"
            data-nid={nid}
            href={finalPath}>
            {ratingCount ? ratingCount : "0"}{" "}
            {ratingCount > 1 ? t("reviews") : t("review")}{" "}
          </a>
        </div>
      </div>
    </div>
  </div>)
}
export default Rating
